import type { FormKitNode, FormKitTypeDefinition } from "@formkit/core";
import {
	outer,
	inner,
	wrapper,
	label,
	help,
	messages,
	message,
	icon,
	prefix,
	suffix,
	casts,
	createSection,
} from "@formkit/inputs";
import LoanApplicationFormInputDate from "./LoanApplicationFormInputDate.vue";
import { getDisplayDate } from "@/helpers/uiHelpers";
import { markRaw } from "vue";

const dateInputName = "LoanApplicationFormInputDate";

function dateFunctions(node: FormKitNode) {
	node.on("created", () => {
		if (!node.context?.handlers) {
			return;
		}

		node.context.handlers.getDisplayDate = getDisplayDate;
	});
}

const dateInputSchema = createSection("input", () => ({
	$cmp: dateInputName,
	props: {
		context: "$node.context",
	},
}));

/**
 * Input definition for a text.
 * @public
 */
export const loanApplicationFormInputDate: FormKitTypeDefinition = {
	/**
	 * The actual schema of the input, or a function that returns the schema.
	 */
	schema: outer(
		wrapper(
			label("$label"),
			inner(
				icon("prefix", "label"),
				prefix(),
				dateInputSchema(),
				suffix(),
				icon("suffix"),
			),
			() => ({
				$el: "span",
				children: "$handlers.getDisplayDate($value)",
			}),
		),
		help("$help"),
		messages(message("$message.value")),
	),
	/**
	 * The type of node, can be a list, group, or input.
	 */
	type: "input",
	/**
	 * The family of inputs this one belongs too. For example "text" and "email"
	 * are both part of the "text" family. This is primary used for styling.
	 */
	family: "text",
	/**
	 * An array of extra props to accept for this input.
	 */
	props: ["twoDigitYearCentury"],
	/**
	 * Forces node.props.type to be this explicit value.
	 */
	forceTypeProp: "text",
	/**
	 * Additional features that should be added to your input
	 */
	features: [casts, dateFunctions],
	/**
	 * The key used to memoize the schema.
	 */
	schemaMemoKey: "gt7xd1t44gn",
	library: {
		[dateInputName]: markRaw(LoanApplicationFormInputDate),
	},
};
